
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../httpService/httpService";
import { useParams } from "react-router-dom";

export const fetchClientCampaign = createAsyncThunk(
  "clientCampaign/fetchClientCampaign",
  async ({search, limit = 10,page=1 ,userId }, { rejectWithValue }) => {
    console.log("inside api call for fetching campaign") ;
    console.log(search);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(
        `/fetch-all-campaigns-client/admin/${userId}`,
        {
          params: {
            campaign_name: search.campaign_name,
            start_date: search.createdAtFrom,
            end_date: search.createdAtTo,
            client_name: search.client_fullName,
            region: search.regions,
            city: search.cities,
            count: search.sites,
            page: page,
            limit: limit,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch clients");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching clients"
      );
    }
  }
);

const fetchClientCampaignSlice = createSlice({
  name: "clientCampaign",
  initialState: {
    items: [],
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientCampaign.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchClientCampaign.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchClientCampaign.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export default fetchClientCampaignSlice.reducer;
